import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import '../../Components/report.css';
import Response from "../../Components/Response/Student";
import { Link } from 'react-router-dom';

function ReviewEvaluations (props) {
    const {
        user,
        sprint,
        sprintEvaluations,
    } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const mappedQuestionsAndAnswers = () => {
        if (!sprintEvaluations || !sprintEvaluations.length) {
          return (
            <div>
              <img
                src={"/loading.svg"}
                alt="Loading..."
              />
            </div>
          );
        }
        const studentEvaluations = sprintEvaluations.filter(thisEval => thisEval.studentReviewed === user._id)

        const questionAnswerArray = []
        let questionAnswer;
        for (let i = 0; i < sprint.questionAnswerTypePairs.length; i++) {
          questionAnswer = sprint.questionAnswerTypePairs[i];
          questionAnswerArray.push({
            question: questionAnswer.question,
            answers: [],
            answerType: questionAnswer.answer,
            yValues: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0 },
            yesNo: { classYes: 0, classNo: 0, studentYes: 0, studentNo: 0 },
            classAnswers: [],
          });
        }

        for (let i = 0; i < studentEvaluations.length; i++) {
            for (let j = 0; j < questionAnswerArray.length; j++) {
                const answer = studentEvaluations[i]?.questionAnswerPairs[j]?.answer
                if (questionAnswerArray[j].answerType === "Y/N") {
                    questionAnswerArray[j].yesNo[`student${answer}`] += 1
                } else {
                    if(answer)
                        questionAnswerArray[j].answers.push(answer);
                }
            }
        }

        let response;
        const createMatchingQuestionFinder = questionAnswer => {
            return entry => entry.question === questionAnswer.question;
        };
        let questionFinder;
        for (let i = 0; i < questionAnswerArray.length; i++) {
            questionAnswer = questionAnswerArray[i];
            questionFinder = createMatchingQuestionFinder(questionAnswer);
            for (let evaluation of sprintEvaluations) {
                const found = evaluation.questionAnswerPairs.find(questionFinder)
                if (questionAnswer.answerType === "Range") {
                    response = parseInt(found?.answer || '0', 10);
                    questionAnswer.classAnswers.push(response)
                    questionAnswer.yValues[response] += 1
                } else if (questionAnswer.answerType === "Y/N") {
                    response = found?.answer;
                    questionAnswer.yesNo[`class${response}`] += 1
                }
            }
        }

        return questionAnswerArray.map((questionAnswer, index) => {
            return <Response
                       questionAnswer={questionAnswer}
                       index={index}
                       key={index + "questionAnswer"}
                   />
        });
    }

    return (
        <div className="reportPage">
            <div className="backButton">
                <Link to="/student">
                    <img src={require("../../../Images/leftArrow.png")} alt="<-"/>
                    Return to Dashboard
                </Link>
            </div>
            <div className="responsesWrapper">
                <h1>Your Responses</h1>
                {mappedQuestionsAndAnswers()}
            </div>
        </div>
    );
}

export default connect(state => state.root, {})(ReviewEvaluations);
